import type { ObserverState } from './observerContext';

/*
  Словарь состояний компаньона: цвет, темп смены цвета и размер (docs/observer-design.md §4.6).
  Вынесен из компонента, чтобы файл тела экспортировал только компонент.
  Операция — синий info: фиолетовый только у того, что начал ИИ (R10). «Ждёт ответа» — коралл: его несёт
  ритм, а не новый цвет (spec-3 §2).
*/

export const STATE_COLOR: Record<ObserverState, string> = {
  idle: 'var(--brand)',
  thinking: 'var(--ai)',
  writing: 'var(--info)',
  download: 'var(--info)',
  upload: 'var(--brand)',
  update: 'var(--info)',
  asking: 'var(--brand)',
  success: 'var(--success)',
  error: 'var(--danger)',
};

/** Темп смены цвета: срочность события. */
export const STATE_COLOR_MS: Record<ObserverState, number> = {
  error: 0,
  success: 120,
  idle: 800,
  thinking: 320,
  writing: 320,
  download: 320,
  upload: 320,
  update: 320,
  asking: 800,
};

/** Размер как громкость: покой, работа, долгая операция. */
export const STATE_SIZE: Record<ObserverState, number> = {
  idle: 26,
  thinking: 32,
  writing: 32,
  download: 32,
  upload: 32,
  update: 48,
  asking: 26,
  success: 26,
  error: 26,
};
